"use client";

import { createContext, useContext, type ReactNode } from "react";

import { NowProvider } from "../NowProvider";

import { type LoansPageState, useLoansPageState } from "./useLoansPageState";

const LoansPageContext = createContext<LoansPageState | undefined>(undefined);

export function useLoansPage() {
  const context = useContext(LoansPageContext);
  if (!context) throw new Error("useLoansPage must be called within a LoansPageProvider");
  return context;
}

interface LoansPageProviderProps {
  children: ReactNode;
}

export function LoansPageProvider(props: LoansPageProviderProps) {
  const { children } = props;

  const state = useLoansPageState();

  // Mounted here so every loan view inherits one clock: both pages wrap this
  // provider, and `useLoanTimestamps` reads the time from it.
  return (
    <LoansPageContext.Provider value={state}>
      <NowProvider>{children}</NowProvider>
    </LoansPageContext.Provider>
  );
}
